'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('feedback', {
      url: '/admin/feedback',
      template: '<feedback></feedback>'
    });
}



// WEBPACK FOOTER //
// ./client/app/admin/feedback/feedback.routes.js